import { gql } from '@apollo/client';

/*******************/
/**     QUERY     **/
/*******************/

/**
 *
 * @param query Query params including device identifier, language, and section to load
 * @param horizontalParams Horizontal pagination parameters
 *
 * Epg query
 */
const epg = `epgs(
  query: $query
  horizontalParams: $epgHorizontalParams
) {
    items {
      channel
      epgs {
        _id
        ageCode
        category
        actors
        allowRecord
        beginTime
        catchup
        channel
        channelName
        country
        countries {
          countryCode
          localizable {
            en
            es
            ca
          }}
        created
        directors
        duration
        endTime
        episode
        episodeTitle
        eventId
        fastVodEnabled
        gender {
          name
          titles {
            en
            es
            ca
          }
        }
        hosts
        kind
        language
        length
        moviePictures {
          background
          backgroundSrc
          photo
          photoSrc
          poster
          posterSrc
        }
        premiereTVup
        productors
        season
        seasonId
        serieId
        score
        synopsis
        synopsisEpisode
        title
        type
        writers
        year
      }
      totalItems
      pages
    }
  }`;

/**
 *
 * @param query Query params including device identifier, language, and section to load
 * @param epgsHorizontalParams Reels horizontal pagination parameters
 * @returns Section GraphQL query
 */
const query = gql`
  query Epg(
    $query: EpgQuerySection!
    $epgHorizontalParams: QueryParams!
  ) {
    ${epg}
  }
`;

export default query;
